<template>
  <div class="face-recognition">
    <Progress progress="95"></Progress>
    <!-- 默认上传视频 -->
    <div class="upload-video">
      <p class="tag" @click="showGuide()">{{$t('openAccount.t000103')}}</p>
      <p class="title">{{$t('openAccount.t000104')}}</p>
      <img src="@/assets/images/img_record_process.png" class="img" />
      <p class="tips">{{$t('openAccount.t000105')}}<span>{{$t('openAccount.t000106')}}</span>{{$t('openAccount.t000107')}}</p>
      <a class="btn-upload" v-if="!isChange" @click="toFeceCheck">{{ $t('openAccount.t000139') }}</a>
      <Uploader
        v-if="isChange"
        class="btn-upload"
        accept="video/mp4, video/quicktime, video/x-msvideo, video/*"
        capture="user"
        :after-read="uploadAfter"
        :max-size="1024 * 1024 * 30"
        @oversize="handleUploadOversize"
      >
        <span>{{ $t("openAccount.t000052") }}</span>
      </Uploader>
    </div>
<!--    失败弹窗 -->
    <van-popup v-model="isErrorPopup" class="is-error-popup" position="center">
      <div class="is-error-main">
        <p class="tip">{{ $t('openAccount.t000055') }}</p>
        <p class="message">{{ errorMsg }}</p>
        <div class="btn-box">
          <Uploader
            class="btn"
            accept="video/mp4, video/quicktime, video/x-msvideo, video/*"
            capture="user"
            :after-read="uploadAfter"
            :max-size="1024 * 1024 * 30"
            @oversize="handleUploadOversize"
            >
            <span>{{ $t("openAccount.t000052") }}</span>
          </Uploader>
          <div class="btn" @click="toFeceCheck">{{ $t('openAccount.t000053') }}</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="isGuideDialog" class="guide-dialog" position="center">
      <div class="guide-img">
        <p class="title">{{$t('openAccount.t000111')}}</p>
        <img src="@/assets/images/img_record_tips_modal.png" class="img">
        <a @click="isGuideDialog = false" class="btn">{{$t('openAccount.t000112')}}</a>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Progress from "../components/Progress.vue";
import { Popup, Toast, Uploader } from "vant";
import { getBrowser } from "@/utils/browser";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";
import { resolveCustomerConfirmationPath } from "../utils/resolveCustomerConfirmationPath";
export default {
  name: "FaceRecognitionIndex",
  components: {
    Progress,
    Uploader,
    [Popup.name]: Popup,
  },
  data() {
    return {
      isChange: false,
      process_id: "",
      isGuideDialog: false,
      isErrorPopup: false,
      errorMsg: this.$t('openAccount.t000138')
    };
  },
  async created() {

    if(getBrowser().isApp){
      setStatementDetailInfo({
        headerTitle: this.$route.meta.title,
        hideTitle: '0'
      })
    }
    // 获取第三方地址  接口
    // 认证
    // 成功  --- 下一步
    // 失败 --
    // 1 手动+上传
    // 2 再来一次  ↑
    // 1----- 上传成功  下一步    上传失败 ↑
    const { response, bizId, change } = this.$route.query;
    this.isChange = change == 1;
    try {
      await this.getData();
    } catch(err) { }
    if (response) {
      // 调PHP接口 查看结果
      const loading = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis
        .getZolozCheckResultApi({ bizId, action_module: 'connect' })
        .then(res => {
          // 其他 失败 弹窗
          loading.clear()
          const { result, connectResult, order_no } = res;
          // 成功 下一步
          if(result.resultStatus == 'S' && connectResult == 'Success'){
            this.$toast({
              message: this.$t('openAccount.t000143'),
              forbidClick: true,
              duration: 1500,
              onClose: () => {
                this.next(order_no)
              }
            })
          }else{
            this.errorMsg = this.$t('openAccount.t000138');
            this.isErrorPopup = true;
          }
          // this.next();
        })
        .catch(err => {
          this.isErrorPopup = true;
          this.errorMsg = this.$t('openAccount.t000140');
          
        });
    }

  },
  methods: {
    getData() {
      return this.$apis.accountSituationV2({
        step_code: "1",
      }).then(async res => {
        this.process_id = res?.process_info["1"]?.process_id || res?.get_open_account_info?.open_status;

      });
    },
    toFeceCheck() {
      const call = ()=>{
        if (!this.isUploaded) {
          const { origin, pathname } = window.location;
          
          this.$apis
            .zolozInitializeApi({
              completeCallbackUrl: origin + pathname,
              interruptCallbackUrl: origin + pathname,
              action_module: 'connect'
            })
            .then(res => {
              if (res.code && res.code === 100495) {
                this.isErrorPopup = true;
                return false;
              }
              // eslint-disable-next-line prefer-const
              let { h5Url, langPack } = res;
              const clientCfg = encodeURIComponent(res.clientCfg);
              let url = `${h5Url}?clientcfg=${clientCfg}`;
              if(langPack){
                langPack = encodeURIComponent(langPack);
                url = `${url}&langPack=${langPack}`
              }
              if(getBrowser().isApp){
                setStatementDetailInfo({
                  headerTitle: this.$route.meta.title,
                  hideTitle: '1'
                })
              }
              window.location.replace(url);
            }).catch(()=>{
            this.errorMsg = this.$t('openAccount.t000140');
            this.isErrorPopup = true;
          });
        }
      }
      if(getBrowser().isApp){
        this.$JsBridge.callHandler('cameraPermissions', '', (res) => {
          
          if (res == true || res == 'true') {
            call();
          }else {
            this.$toast(this.$t('openAccount.t000137'))
          }
        })
      }else{
        call()
      }
    },
    // 视频最大限制
    handleUploadOversize() {
      this.$toast.fail(this.$t('openAccount.t000113_1'));
    },
    uploadAfter(file){
      if(file?.content?.length >= 100){
        const log = {
          ...file,
          file: ''
        }
        
        const params = new FormData();
        params.append("video", file.file);
        this.$apis.accountUploadFaceVideo(params).then(res =>{
          if(res.code && res.msg){
            this.$toast(res.msg)
            return
          }
          const { order_no } = res;
          this.next(order_no);
        })
      }

    },
    showGuide(){
      this.isGuideDialog = true;
    },
    next(order_no){
      if(!order_no){
        order_no = this.$route.query.orderNo;
      }
      const params = {
        process_id: this.process_id,
        step_code: '13-2',
        step_order: 13,
        config_data: {
          order_no
        }
      };
      // 后端说没有上报13-2却跳转了页面，finally换成then
      this.$apis.supplementSaveApi(params).then(async (res)=>{
        if(res.code && res.msg){
          this.$toast(res.msg)
          return
        }
        let path = "/open-account/customerConfirmation";
        if(this.$route.query.change == 1){
          path = "/open-account/home";
        } else {
          path = await resolveCustomerConfirmationPath(this.$apis);
        }
        this.$router.push({
            path
          })
      })
    }
  }
};
</script>

<style scoped lang="less">
.face-recognition {
  padding-top: 62px;
  background: #fff;
  min-height: 100%;
  .upload-video {
    display: flex;
    flex-direction: column;
    position: relative;
    padding-top: 80px;
    .tag {
      position: absolute;
      top: 40px;
      left: 0;
      padding: 0 20px 0 10px;
      color: #999;
      height: 50px;
      line-height: 50px;
      border-radius: 0 50px 50px 0;
      border: 1px solid #d7d7d7;
      border-left: none;
    }
    .title {
      margin-top: 20px;
      text-align: center;
      opacity: 0.6;
      font-size: 32px;
      color: #62688d;
      padding-top: 0;
    }
    .img {
      display: block;
      margin: 30px auto 0;
      width: 400px;
    }
    .tips {
      margin-top: 30px;
      text-align: center;
      font-size: 48px;
      font-weight: 700;
      line-height: 1;
      span {
        color: #ff6034;
      }
    }
  }
  .btn-upload {
    display: flex;
    margin: 60px 50px 0;
    background: #17161c;
    color: #fff;
    height: 100px;
    border-radius: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 32px;
    justify-content: center;
    font-weight: 500;
    ::v-deep .van-uploader__wrapper {
      flex: 1;
      justify-content: center;
      .van-uploader__input-wrapper{
        flex: 1;
      }
    }
  }

  .guide-dialog{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0);
    .guide-img{
      width: 70%;
      text-align: center;
      .title{
        font-weight: bold;
        color: #fff;
        font-size: 46px;
      }
      .img{
        margin-top: 30px;
        display: block;
        width: 100%;
      }
      .btn{
        display: block;
        margin-top: 30px;
        line-height: 80px;
        border: #fff solid 1px;
        border-radius: 80px;
        color: #fff;
        font-size: 32px;
      }
    }
  }
  .is-error-popup{
    background: #ffffff;
    border-radius: 32px;
    width: 600px;
    text-align: center;
    &.van-popup{
      p{
        color: #17161c;
      }
      .is-error-main{
        padding: 45px;
        .tip{
          font-size: 36px;
          font-weight: 500;
        }
        .message{
          margin-top: 32px;
          color: #747377;
          font-size: 32px;
        }
        .btn-box{
          display: flex;
          margin-top: 40px;
          .btn{
            flex: 1;
            color: #17161C;
            height: 104px;
            line-height: 104px;
            border-radius: 104px;
            font-size: 28px;
            font-weight: 500;
            background: rgba(15,15,47,0.04);
            & ~ .btn{
              margin-left: 20px;
              color: #fff;
              background: #17161C;
            }

            ::v-deep .van-uploader__wrapper {
              flex: 1;
              justify-content: center;
              .van-uploader__input-wrapper{
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
}
.black-theme{
  .face-recognition{
   background: #1B1C24;
    .upload-video{
      .title{
        color: #FFFFFF;
      }
      .tips{
        color: #FFFFFF;
      }
    }
    .btn-upload{
      background: #377CFB;
    }
  }
  .is-error-popup{
    background: #1B1C24;
    .is-error-main{
      .tip{
        color: #FFFFFF;
      }
      .message{
        color: #9D9D9F !important;
      }
      .btn-box{
        .btn{
          background: #377CFB !important;
        }
        .van-uploader{
          background: #8E92A3 !important;
          color: #FFFFFF !important;
        }
      }

    }


  }
}
</style>
